import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapObjectHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapObjectHelper.js.map
